import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, blue, unityBlue } from '../colors';
import { GetThemeOptions } from '../../theme';

export const secondaryColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityBlue[600],
          highContrast: unityBlue[800],
          lowContrast: unityBlue[100],
        }
      : {
          main: unityBlue[400],
          highContrast: unityBlue[300],
          lowContrast: unityBlue[700],
        };
  }
  return mode === 'light'
    ? {
        main: blue[600],
        highContrast: blue[800],
        lowContrast: blue[150],
      }
    : {
        main: blue[500],
        highContrast: blue[300],
        lowContrast: blue[700],
      };
};
